import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { FaUpload, FaShareAlt, FaTrash, FaFolderPlus } from "react-icons/fa";
import "./folderview.css";

const FolderView = () => {
  const { folderId } = useParams();
  const location = useLocation();
  const folder = location.state;

  const [files, setFiles] = useState([]);
  const [subFolders, setSubFolders] = useState([]);
  const [newFolderName, setNewFolderName] = useState("");
  const [uploadFile, setUploadFile] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));

  // LOAD FILES + SUBFOLDERS
  useEffect(() => {
    fetch(`http://localhost:5000/api/list-files?folderId=${folderId}&uid=${user.uid}`)
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          setFiles(data.files.filter(f => f.mimeType !== "application/vnd.google-apps.folder"));
          setSubFolders(data.files.filter(f => f.mimeType === "application/vnd.google-apps.folder"));
        }
      });
  }, [folderId]);

  // UPLOAD FILE
  const handleFileUpload = async () => {
    if (!uploadFile) return;

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("folderId", folderId);

    const res = await fetch("http://localhost:5000/api/upload-file", {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    if (data.ok) {
      alert("Uploaded!");
      window.location.reload();
    }
    else {
      alert("Upload failed: " + data.error);
    }
  };

  // CREATE SUBFOLDER
  const createSubFolder = async () => {
    if (!newFolderName.trim()) return;

    const res = await fetch("http://localhost:5000/api/create-subfolder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        parentId: folderId,
        folderName: newFolderName,
        uid: user.uid
      }),
    });

    const data = await res.json();
    if (data.ok) {
      alert("Subfolder created!");
      window.location.reload();
    }
  };

  // DELETE FILE
  const deleteFile = async (fileId) => {
    const res = await fetch("http://localhost:5000/api/delete-file", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fileId, folderId }),
    });

    const data = await res.json();
    if (data.ok) {
      alert("Deleted!");
      window.location.reload();
    }
  };

  return (
    <div className="folder-view-container">

      <h2>📁 {folder.folderName}</h2>
      <p style={{ color: "#777" }}>Folder ID: {folderId}</p>

      {/* ACTION BAR */}
      <div className="action-bar">

        {/* FILE UPLOAD */}
        <label className="upload-btn">
          <FaUpload /> Upload File
          <input type="file" onChange={(e) => setUploadFile(e.target.files[0])} hidden />
        </label>

        <button className="primary-btn" onClick={handleFileUpload}>
          Upload
        </button>

        {/* CREATE SUBFOLDER */}
        <input
          type="text"
          placeholder="New subfolder name..."
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
          className="subfolder-input"
        />

        <button className="primary-btn" onClick={createSubFolder}>
          <FaFolderPlus /> Create Subfolder
        </button>

      </div>

      {/* SUBFOLDER SECTION */}
      {subFolders.length > 0 && (
        <>
          <h3>📂 Subfolders</h3>
          <div className="file-grid">
            {subFolders.map((f) => (
              <div className="folder-card" key={f.id}>
                <h3>📁 {f.name}</h3>
                <a
                  onClick={() =>
                    window.location.assign(`/main/folder/${f.id}`)
                  }
                  className="open-btn"
                >
                  Open
                </a>
              </div>
            ))}
          </div>
        </>
      )}

      {/* FILE SECTION */}
      <h3>📄 Files</h3>

      {files.length === 0 ? (
        <p>No files uploaded yet.</p>
      ) : (
        <div className="file-grid">
          {files.map((file) => (
            <div className="file-card" key={file.id}>

              <h4>{file.name}</h4>

              <div className="file-actions">
                <a href={file.webViewLink} target="_blank" className="open-btn">Open</a>

                <button className="share-btn">
                  <FaShareAlt /> Share
                </button>

                <button className="delete-btn" onClick={() => deleteFile(file.id)}>
                  <FaTrash />
                </button>
              </div>

            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default FolderView;
